module.exports = __webpack_public_path__ + "img/title-bg.a9f49ca0.png";